import { render, staticRenderFns } from "./dealTv.vue?vue&type=template&id=e696cdce&scoped=true&"
import script from "./dealTv.vue?vue&type=script&lang=js&"
export * from "./dealTv.vue?vue&type=script&lang=js&"
import style0 from "./dealTv.vue?vue&type=style&index=0&id=e696cdce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e696cdce",
  null
  
)

export default component.exports